import React, { useState, useRef, useCallback, useEffect, useMemo } from "react";
import { Button, Table, message, Spin } from "antd";
import { YhFormBox } from "@/components/YhFormBoxVertical";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, ISelectOption } from "@/components/YhFormBoxVertical/Types";
import { useMaintenanceDetailsModel } from "./maintenanceDetailsModels";
import { useDictModel } from "@/views/base/dict/dictModel";
import useGlobalModel from "@/model/globalModel";
import { RouterParamType } from "@/model/navModel";
import { IYhFormRef } from "@/components/YhFormBox/Types";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";
import { YhBox } from "@/components/YhBox";
import { ITopType } from "@/types/ScmTypes";
import { YHDrawer } from "@/components/YhDrawer";
import { ItemTableBox } from "./itemTableBox";
import { MaterialTableBox } from "./materialTableBox";
import { ItemModal } from "./itemModal";
import { MaterialModal } from "./materialModal";
import { HistoryModel } from "@/views/historyModel";
import { ConsumeHistoryModel } from "@/views/commonModule/consumeHistoryModel";
import { RepairHistoryModel } from "@/views/commonModule/repairHistoryModel";
import { momentFormats } from "@/utils/utils";

export const ThreeServiceModal: React.FC<ITopType> = ({ id, mode, IFormRef }) => {
  const { getTreeNodeName, getTreeNodeOne, getSelectedDictOne } = useDictModel();
  const { shopAndOrg: { shopId, shopCode, shopName } } = useGlobalModel();
  const {
    threeServiceModal: visible,
    setThreeServiceModal,
    setItemModel,
    setMaterialModel,
    addDataItemSource,
    addDataMaterialSource,
    setAddDataItemSource,
    setAddDataMaterialSource,
    saveThreeServiceInfo,
    detailAddForm,
    historyVisible, setHistoryVisible,
    historyRow,
    consumeHistoryModel,
    consumeHistoryVisible, setConsumeHistoryVisible,
    repairHistoryModel,
    popupMode, setPopupMode,
    repairHistoryVisible, setRepairHistoryVisible, detailEditForm,
    SBcode, setSBcode, detailSBItemEditList, detailSBItemAddList
  } = useMaintenanceDetailsModel();

  // 实体数据状态
  const [entityData, setEntityData] = useState<{ fetching: boolean; data: { value: string; text: string }[] }>({
    fetching: false,
    data: []
  });

  // 三包信息表单数据
  const [threeServiceForm, setThreeServiceForm] = useState<any>({});
  // 监听 popupMode 和 SBcode 的变化，加载对应的三包信息
  useEffect(() => {
    if (popupMode === 'edit' && SBcode) {
      // 根据 mode 选择对应的列表
      const currentList = detailSBItemEditList;
      // 查找对应的三包信息
      const currentThreeService = currentList.find(item => item.id === SBcode);

      if (currentThreeService) {
        // 填充表单数据
        setThreeServiceForm({
          ...currentThreeService,
          threeGuaranteesBrand: currentThreeService.threeGuaranteesBrand,
          claimNumber: currentThreeService.claimNumber,
          statementNumber: currentThreeService.statementNumber,
          materialAmount: currentThreeService.materialAmount,
          hourlyWage: currentThreeService.hourlyWage,
          travelExpenses: currentThreeService.travelExpenses,
          mealSupplement: currentThreeService.mealSupplement,
          otherAmount: currentThreeService.otherAmount,
          outboundAmount: currentThreeService.outboundAmount,
          totalClaim: currentThreeService.totalClaim,
          faultHandle: currentThreeService.faultHandle,
          totalHourlyWage: currentThreeService.totalHourlyWage,
          repairTime: currentThreeService.repairTime,
          repairTimes: momentFormats(currentThreeService.repairTime),
          maintenanceStaff: currentThreeService.maintenanceStaff,
          workHour: currentThreeService.workHour,
          ciBusinessEntityId: currentThreeService.ciBusinessEntityId
        });
      }
    } else if (popupMode === 'add') {
      setThreeServiceForm({});
      setAddDataItemSource([]);
      setAddDataMaterialSource([]);
    }
  }, [popupMode, SBcode, mode]);


  // 表单配置（基本信息）
  const threeServiceFormItem: IYhFormItemsBox = {
    title: <span>基本信息</span>,
    items: [
      {
        type: FormItemTypeEnum.Select,
        fieldLabel: "三包品牌",
        fieldName: "threeGuaranteesBrand",
        placeholder: "请选择三包品牌",
        options: getSelectedDictOne(DictCodeEnmu.MAINTENANCESB_BRAND),
        rules: [{ required: true, message: "请选择三包品牌" }],
        span: 4
      },
      // {
      //   type: FormItemTypeEnum.Input,
      //   fieldLabel: "所属实体",
      //   fieldName: "ciBusinessEntityId",
      //   placeholder: "请选择所属实体",
      //   disable: true,
      //   span: 4
      // },
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "索赔单号",
        fieldName: "claimNumber",
        placeholder: "请输入索赔单号",
        span: 4
      },
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "结算单号",
        fieldName: "statementNumber",
        placeholder: "请输入结算单号",
        span: 4
      },
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "材料费",
        fieldName: "materialAmount",
        placeholder: "请输入材料费",
        span: 4
      },
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "工时费",
        fieldName: "hourlyWage",
        placeholder: "请输入工时费",
        span: 4
      },
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "外出费",
        fieldName: "travelExpenses",
        placeholder: "请输入外出费",
        span: 4
      },
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "餐补费",
        fieldName: "mealSupplement",
        placeholder: "请输入餐补费",
        span: 4
      },
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "其他费用",
        fieldName: "otherAmount",
        placeholder: "请输入其他费用",
        span: 4
      },
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "出库金额",
        fieldName: "outboundAmount",
        placeholder: "出库金额",
        span: 4
      },
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "索赔总额",
        fieldName: "totalClaim",
        placeholder: "索赔总额",
        span: 4
      },
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "故障处理",
        fieldName: "faultHandle",
        placeholder: "请输入故障处理",
        span: 4
      },
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "工时费汇总",
        fieldName: "totalHourlyWage",
        placeholder: "自动计算：工时费+外出费+餐补费",
        disable: true,
        span: 4
      }, {
        type: FormItemTypeEnum.Input,
        fieldLabel: "工时定额",
        fieldName: "workHour",
        placeholder: "请输入工时定额",
        span: 4
      },
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "维修时间",
        fieldName: "repairTimes",
        placeholder: "维修时间",
        disable: true,
        span: 4
      },
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "维修人员",
        fieldName: "maintenanceStaff",
        placeholder: "维修人员",
        disable: true,
        span: 4
      },

    ]
  };
  const onChange = (changedValues: any, allValues: any) => {
    // 自动计算其他费用 = 工时费 + 外出费 + 餐补费
    if (changedValues.hourlyWage !== undefined || changedValues.travelExpenses !== undefined || changedValues.mealSupplement !== undefined) {
      const hourlyWage = parseFloat(allValues.hourlyWage) || 0;
      const travelExpenses = parseFloat(allValues.travelExpenses) || 0;
      const mealSupplement = parseFloat(allValues.mealSupplement) || 0;
      const totalHourlyWage = hourlyWage + travelExpenses + mealSupplement;
      setThreeServiceForm((prev: any) => ({
        ...prev,
        totalHourlyWage: totalHourlyWage.toString()
      }));
    }

    // 更新表单数据
    setThreeServiceForm((prev: any) => ({
      ...prev,
      ...changedValues
    }));
  }
  const poFromConfig: IYhFormBox = {
    formRef: IFormRef,
    labelCol: { span: 4 },
    labelAlign: "right",
    formValues: threeServiceForm,
    onChange,
    boxs: [threeServiceFormItem]
  };

  // 保存逻辑
  const onOk = async () => {
    try {
      await IFormRef.current?.validateFields();

      const data = {
        ...threeServiceForm,
        maintenanceCode: mode === "add" ? detailAddForm.maintenanceCode : detailEditForm.maintenanceCode,
        itemList: addDataItemSource,
        materialList: addDataMaterialSource
      };

      const result = await saveThreeServiceInfo(data, mode, popupMode);
      if (result) {
        message.success("保存成功");
        setThreeServiceModal(false);
        setThreeServiceForm({});
        setAddDataItemSource([]);
        setAddDataMaterialSource([]);
        setPopupMode("");
        setSBcode(null);
      }
    } catch (error) {
      message.error("保存失败，请检查表单");
    }
  };

  const onCancel = () => {
    setThreeServiceModal(false);
    setThreeServiceForm({});
    setAddDataItemSource([]);
    setAddDataMaterialSource([]);
    setPopupMode("");
    setSBcode(null);
  };

  return (
    <YHDrawer
      visible={visible}
      onOk={onOk}
      onCancel={onCancel}
      title="三包信息管理"
      width={1500}
      showFooter={true}
    >
      {/* 基本信息表单 */}
      <YhFormBox {...poFromConfig} />

      {/* 当选择了三包品牌时才显示维修项目和维修用料 */}
      {popupMode == 'edit' && (
        <>
          <ItemTableBox {...{ id, mode }} IFormRef={IFormRef} />
          <MaterialTableBox {...{ id, mode }} IFormRef={IFormRef} />
          <MaterialModal {...{ id, mode }} />
          <ItemModal {...{ id, mode }} />
        </>
      )}

      <HistoryModel
        visible={historyVisible}
        materialCode={historyRow.materialCode as string}
        materialName={historyRow.materialName as string}
        onCancel={() => setHistoryVisible(false)}
      />
      <ConsumeHistoryModel
        visible={consumeHistoryVisible}
        name={consumeHistoryModel.customerName}
        onCancel={() => setConsumeHistoryVisible(false)}
      />
      <RepairHistoryModel
        visible={repairHistoryVisible}
        licensePlate={repairHistoryModel.licensePlate}
        onCancel={() => setRepairHistoryVisible(false)}
      />
    </YHDrawer>
  );
};